import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, signal, input, output } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { TvangebotimagevideoComponent } from '@app/components/modals/tvangebotimagevideo/tvangebotimagevideo.component';
import { MatDialog } from '@angular/material/dialog';
import { MapService } from '@app/services/map.service';
import moment from 'moment';
@Component({
    selector: 'clever-ratehawk-detail',
    templateUrl: './ratehawk-detail.component.html',
    styleUrls: ['./ratehawk-detail.component.scss'],
    standalone: false
})
export class RatehawkDetailComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() datas: any;
    @Input() hotel: any;
    readonly sendAlt = output<any>();
    readonly sendBook = output<any>();
    private unsubscribe$ = new Subject();

    deskMode: boolean = true;
    showMap: boolean = false;
    prcdetail: string = '';
    desktopTemplate: string = '';
    map = null;
    curentContent: number = 0;
    categoryAr: number[] = [];
    images: any[];
    adults = signal<number>(0);
    child = signal<number>(0);
    dauer = signal<string>('0');

    constructor(
        protected mediaObserver: BreakpointObserver,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        protected mapService: MapService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
    }

    ngOnInit(): void {
        // console.log(this.datas)
        this.dauer.set(moment.duration(moment(this.datas.filter.checkout)
                    .diff(moment(this.datas.filter.checkin))).asDays() + '');
        this.initMedia();
        this.initTravelers();
        this.initImages();
    }

    async initImages() {
        this.images = [];
        this.cdr.detectChanges();
        for (let i = 0; i < this.hotel.images?.length; i++) {
            this.images.push(this.hotel.images[i].replace('{size}', '640x400'));

        }

        const datas = this.datas;
        if (this.images?.length > 0 && datas.firstBilder?.length > 0) {
            const pos = this.images.indexOf(datas.firstBilder);
        }

        const catg = Number(String(this.hotel?.star_rating).replace(/,/g, '.').replace(/\+/g, ''));
        for (let i = 0; i < Math.floor(catg); i++) {
            this.categoryAr.push(1);
        }
        if (catg > Math.floor(catg)) {
            this.categoryAr.push(0.5);
        }
        this.cdr.detectChanges();
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
            this.deskMode = true;
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
            this.deskMode = true;
        }
        this.cdr.detectChanges();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.onMapReady();
        }, 100);
    }

    async initTravelers() {
        let ad = 0;
        let child = 0;
        const datas = this.datas;
        for (let i = 0; i < datas.filter?.guests?.length; i++) {
            ad += datas.filter.guests[i].adults;
            child += datas.filter.guests[i].children?.length;
        }

        this.adults.set(ad);
        this.child.set(child);
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    sendAalternative() {
        this.sendAlt.emit(true);
    }

    sendBooking() {
        this.sendBook.emit(true);
    }

    initMaps() {
        this.mapService.Leaflet.marker([this.hotel?.latitude, this.hotel?.longitude],
            {
                icon: this.mapService.Leaflet.icon({
                    iconSize: [25, 41],
                    iconAnchor: [13, 41],
                    iconUrl: 'leaflet/marker-icon.png',
                    shadowUrl: 'leaflet/marker-shadow.png'
                })
            }
        ).bindPopup(this.hotel?.name).addTo(this.map);
        this.map?.invalidateSize();
        this.showMap = true;
        this.cdr.detectChanges();
    }

    onMapReady() {
        if (isPlatformBrowser(this.platformId) && this.hotel?.latitude) {
            this.map = this.mapService.Leaflet.map('map').setView([this.hotel?.latitude, this.hotel?.longitude], 15);
            this.mapService.Leaflet.tileLayer('https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' }).addTo(this.map);
            this.map?.invalidateSize();
            this.initMaps();
        }
    }

    async openImageModal(ev) {
        const target = {
            disableClose: true,
            panelClass: ['full-screen-modal'],
            data: {
                hotel: this.hotel,
                images: this.images,
                videos: [],
                current: ev,
                to800: true,
                desktopTemplate: this.desktopTemplate
            }
        }
        this.dialog.open(TvangebotimagevideoComponent, target);
    }
}
